import { resumeScriptCommand } from "../../commands/scripts/resumeScript";

export async function resumeScriptTui() {
  await resumeScriptCommand();
}
